import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ToggleButton, ToggleButtonGroup, styled } from "@mui/material";

const ReportTypeToggle = ({ deviceConfigId, setComplianceReport, fetchCycles }) => {
    const [reportType, setReportType] = React.useState("comprehensive");

    const handleReportType = (event, newType) => {
        if (newType !== null && newType !== reportType) {
            if (newType === "comprehensive") {
                setComplianceReport(false);
            } else {
                setComplianceReport(true);
            }
            setReportType(newType);
        }
    };

    useEffect(() => {
        // @ts-ignore
        fetchCycles();
    }, [reportType]);

    return (
        <ToggleButtonGroup
            color="secondary"
            value={reportType}
            sx={{ mr: 1 }}
            exclusive
            onChange={handleReportType}
            aria-label="report type">
            <ToggleButton value="comprehensive" aria-label="comprehensive">
                Comprehensive
            </ToggleButton>
            <ToggleButton value="compliance" aria-label="compliance">
                Compliance
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

ReportTypeToggle.propTypes = {
    deviceConfigId: PropTypes.number,
    setComplianceReport: PropTypes.func.isRequired,
    fetchCycles: PropTypes.func.isRequired,
};

export default ReportTypeToggle;
